// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__b1jTR","input":"styles_input__2mXa2"};